import { GameSearchModalProps } from './props';
import GameSearchModalDefaultContent from '../Default';
import GameSearchModalGamesResult from '../GamesResult';
import GameSearchModalEmptySearch from '../Empty';

export default function GameSearchModalContent({
  games,
  isFetchingNextPage,
  isLoading,
  error,
  refetch,
  isSuccess,
  search,
}: GameSearchModalProps) {
  if (search?.length < 3) {
    return <GameSearchModalDefaultContent />;
  }

  if (games?.length === 0 && !isLoading && !error) {
    return <GameSearchModalEmptySearch />;
  }

  return (
    <GameSearchModalGamesResult
      games={games}
      isFetchingNextPage={isFetchingNextPage}
      isLoading={isLoading}
      error={error}
      refetch={refetch}
      isSuccess={isSuccess}
      search={search}
    />
  );
}
